import { 
    findCreateUserRequestById
} from "../../_services/create_user_request.service";

export const findCreateUserRequestByIdEvent = async (id) => {
    return await findCreateUserRequestById(id);
}